
// CadastrarCompra.js

import React, { useState, useEffect } from 'react';
import TipoField from './TipoField';
import CodigoField from './CodigoField';
import DatepickerField from './DatepickerField';
import ModalPesquisarFornecedor from './ModalPesquisarFornecedor'; 
import Box from '@mui/material/Box';
//import Axios from 'axios';
import api from '../config/axiosConfig';
import '../App.css';


function CadastrarCompra({ compra, handleSaveClick, handleCancelaClick }) {

  const [formData, setFormData] = useState({
    codcompra: '',
    dtcompra: '',
    tipo: '',
    nomefor: '',
    codfor: '',
    cnpjfor: '',
    empresa: '',
    codemp: '',
    cnpjemp: '',
    idfornecedor: 0,  // Estado para armazenar dados do fornecedor selecionado
  }); 

  const [pesquisarFornecedor, setPesquisarFornecedor] = useState(false);
  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    const fetchUltimoCodCompra = async () => {
      try {
        const response = await api.get('/compras/ultimocodcompra');
        if (response.data !== null && response.data !== undefined) {
          const novoCodCompra = response.data + 1;
          setFormData(prevFormData => ({
            ...prevFormData,
            codcompra: novoCodCompra
          }));
        }
      } catch (error) {
        console.error('Erro ao obter o último código da compra:', error);
      }
    };

    fetchUltimoCodCompra();
  }, []);

  useEffect(() => {
    // Recuperar os dados da empresa do localStorage
    const storedEmpresa = localStorage.getItem('selectedEmpresaDetails');
    if (storedEmpresa) {
      const empresaDetails = JSON.parse(storedEmpresa);
      setFormData(prevFormData => ({
        ...prevFormData,
        empresa: empresaDetails.empresa,
        codemp: empresaDetails.codemp,
        cnpjemp: empresaDetails.cnpjemp
      }));
    }
  }, []);


  const handleChange = (field, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };
  

  //Função  para  Salvar a Nova Compra
  const handleSaveCompra = async () => {
    if (isSaving) {
      return;
    }

    const mandatoryFields = ['nomefor', 'cnpjfor'];
    const hasErrors = mandatoryFields.some(field => {
      const value = formData[field];
      console.log(`Campo ${field}:`, value);
      return typeof value !== 'string' || value.trim() === '';
   });

    if (hasErrors) {
      alert('O Código da Compra e a Seleção do Fornecedor são obrigatórios.');
      return;
    }

    // Formatar os dados da Compra antes de enviar para o backend
    const dataToSend = {
      ...formData,
      fornecedor: { id: formData.idfornecedor }, // Enviando o ID do fornecedor
    };

    setIsSaving(true);
    try {
      const response = await api.post('/compras/cadastrarcompra', dataToSend, {
        headers: {
          'Content-Type': 'application/json'},
      });

      console.log('Compra criada com sucesso:', response.data);
      window.alert(`Compra: ${dataToSend.codcompra} Cadastrada com Sucesso.`);

      handleSaveClick(response.data.compra);

    } catch (error) {
      console.error('Erro ao criar Compra:', error.response ? error.response.data : error.message);
    } finally {
      setIsSaving(false);
    }
  };
  
  const getDataAtualISO = () => {
    const data = new Date();
    const dia = String(data.getDate()).padStart(2, '0');
    const mes = String(data.getMonth() + 1).padStart(2, '0'); 
    const ano = data.getFullYear();
    return `${ano}-${mes}-${dia}`;
  };

  if (!formData.dtcompra.trim()) {
    formData.dtcompra = getDataAtualISO();
  }

  const handleFornecedorSelecionado = (fornecedor) => {
    setFormData({
      ...formData,
      idfornecedor: fornecedor.id, // Captura o ID do fornecedor selecionado
      nomefor: fornecedor.nomefor,
      codfor: fornecedor.codfor,
      cnpjfor: fornecedor.cnpjfor,
    });
    setPesquisarFornecedor(false);
  };

  const handleOpenModalPesquisaFornecedor = () => {
    setPesquisarFornecedor(true);
  };

  const handleCloseModalPesquisaFornecedor = () => {
    setPesquisarFornecedor(false);
  };


  return (
    <div style={{ minHeight: 'calc(100vh - 20px)', maxWidth: '900px', paddingTop: '10px', margin: '0 auto', textAlign: 'center' }}>
      <div style={{ marginBottom: '20px' }}>
        <h3>Cadastrar Nova Compra</h3>
      </div>
      <div style={{ textAlign: 'left', marginLeft: '20px' }}>

        <div style={{ display: 'flex', marginBottom: '0px' }}>
          <div style={{ width: '100px', marginRight: '20px' }}>
            <label>Compra</label>
            <CodigoField value={formData.codcompra} onChange={value => handleChange('codcompra', value)} />
          </div>
          <div style={{ width: '120px' }}>
            <label translate="no">Data da Compra</label>
            <DatepickerField value={formData.dtcompra} onChange={value => handleChange('dtcompra', value)} />
          </div>
          <div style={{ width: '160px', marginLeft: '20px' }}>
            <label>Tipo da Compra</label>
            <TipoField value={formData.tipo} onChange={value => handleChange('tipo', value)} />
          </div>

          <div style={{ marginLeft: '20px' }}>
            <button className="btn-truncate" onClick={handleOpenModalPesquisaFornecedor} style={{ width: '150px', marginTop: '20px', height: '30px' }}>Seleciona Fornecedor</button>
          </div>
        </div>


        <div style={{ display: 'flex', marginTop: '0px' }}>
          <div style={{ width: '420px', marginRight: '20px' }}>
            <label>Fornecedor:</label>
            <input type="text" value={formData.nomefor} onChange={e => handleChange('nomefor', e.target.value)} readOnly style={{ width: '420px', height: '30px' }} />
          </div>
          <div style={{ width: '100px' }}>
            <label title="Código Fornecedor" style={{ display: 'block', width: '100px', marginTop: '0px',
              overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap'}} translate="no">Cód. Fornecedor</label>
            <input type="text" value={formData.codfor} onChange={e => handleChange('codfor', e.target.value)} readOnly style={{ width: '100px', height: '30px' }} />
          </div>
          <div style={{ width: '150px', marginLeft: '20px' }}>
            <label>CNPJ Fornecedor:</label>
            <input type="text" value={formData.cnpjfor} onChange={e => handleChange('cnpjfor', e.target.value)} readOnly style={{ width: '150px', height: '30px' }} />
          </div>
        </div>
        

        <div style={{ display: 'flex', marginBottom: '20px' }}>
          <div style={{ width: '420px', marginRight: '20px' }}>
            <label>Empresa:</label>
            <input type="text" value={formData.empresa} onChange={e => handleChange('empresa', e.target.value)} style={{ width: '420px', height: '30px' }} />
          </div>

          <div style={{ width: '100px', marginTop: '0px' }}>
            <label style={{ display: 'block', width: '100px', marginTop: '0px' }}>Cód Empresa</label>
            <input type="text" value={formData.codemp} onChange={e => handleChange('codemp', e.target.value)} readOnly style={{ width: '100px', height: '30px' }} />
          </div>            
          <div style={{ width: '150px', marginTop: '0px' }}>
            <label style={{ display: 'block', width: '150px', marginTop: '0px', marginLeft: '20px' }}>CNPJ da Empresa</label>
            <input type="text" value={formData.cnpjemp} onChange={e => handleChange('cnpjemp', e.target.value)} readOnly style={{ width: '150px', marginLeft: '20px', marginTop: '0px', height: '30px' }} />
          </div>

        </div>
        
        </div>

    <Box display="flex" justifyContent="center" alignItems="center" mt={0}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '0px' }}>
        <button  type="button" className='btn-menu' onClick={handleSaveCompra} style={{ width: '100px', height: '30px', padding: '3px 5px', marginRight: '50px', color: 'inherit' }}>
          {isSaving ? 'Salvando...' : 'Salvar'}
        </button>
        <button type="button" className='btn-menu' onClick={handleCancelaClick}
          style={{ width: '100px', height: '30px', padding: '3px 5px', color: 'inherit' }}>Cancelar
        </button>
      </div>
    </Box>

      {pesquisarFornecedor && (
        <ModalPesquisarFornecedor
          isOpen={pesquisarFornecedor}
          onClose={handleCloseModalPesquisaFornecedor}
          onFornecedorSelecionado={handleFornecedorSelecionado}
        />
      )}

    </div>
    
  );
}

export default CadastrarCompra;